export default [{
  path: '/painel-honorarios',
  name: 'painel-honorarios',
  component: () => import('./PainelHonorariosDashboard.vue'),
  meta: {
    resource: 'painelproposta',
    action: 'read',
    navActiveLink: 'painel-honorarios',
    pageTitle: '',
  },
}, {
  path: '/painel-honorarios/contratos',
  name: 'painel-honorarios-contratos',
  redirect: { name: 'configuracaocobranca' },
}, {
  path: '/painel-honorarios/analise-grupo/:grupoEmpresarialId',
  name: 'painel-honorarios-analise-grupo',
  component: () => import('./PainelHonorariosAnaliseGrupo.vue'),
  meta: {
    resource: 'painelproposta',
    action: 'read',
    navActiveLink: 'painel-honorarios',
    pageTitle: 'Análise do Grupo Empresarial',
  },
}, {
  path: '/painel-honorarios/apolices',
  name: 'painel-honorarios-apolices',
  component: () => import('@/app-modulo/comercial/apolices/PainelApolicesDetalhe.vue'),
  meta: {
    resource: 'painelproposta',
    action: 'read',
    navActiveLink: 'painel-honorarios',
    pageTitle: 'Análise de Cobertura das Apólices',
    breadcrumb: [
      {
        text: 'Painel de Honorários',
        to: { name: 'painel-honorarios' },
      },
    ],
  },
}, {
  path: '/painel-honorarios/analise/:empresaId?',
  name: 'painel-honorarios-analise',
  component: () => import('./PainelHonorariosAnalise.vue'),
  meta: {
    resource: 'painelproposta',
    action: 'read',
    navActiveLink: 'painel-honorarios',
    pageTitle: 'Análise de Reprecificação',
  },
}]
